import { isSupportedYear } from '@shared/helpers';
import { ConsoleID, getConsoleState } from 'app/config/Logger';
import { Emojis, LocationCls, ValueCls } from 'app/constants';
import { useAppSelector } from 'app/hooks';
import { getSelectedTeamID, getSelectedYear } from 'app/slices/GamesSlice';
import { getUserAuthState, UserAuthState } from 'app/slices/UserSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

const CONSOLE_ON = getConsoleState(ConsoleID.ViewTeamIndex);

export const ViewTeamIndexRoute: React.FC = () => {
  const navigate = useNavigate();
  const selectedYear = useAppSelector(getSelectedYear);
  const selectedTeamId = useAppSelector(getSelectedTeamID);
  const userAuthState = useAppSelector(getUserAuthState);

  useEffect(() => {
    if (userAuthState !== UserAuthState.LoggedIn && userAuthState !== UserAuthState.Authenticating) {
      const msg = `${Emojis.eyes} %c ViewTeamIndexRoute %c, userAuthState %c ${userAuthState} %c`;
      if (CONSOLE_ON) console.log(msg, LocationCls, '', ValueCls, '');
      navigate(AppRoutes.Auth, { replace: true });
    } else if (isSupportedYear(selectedYear)) {
      const msg = `${Emojis.eyes} %c ViewTeamIndexRoute %c, year %c ${selectedYear} %c ${selectedTeamId} %c`;
      if (CONSOLE_ON) console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '');
      navigate(`${AppRoutes.ViewTeam}/${selectedYear}/${selectedTeamId}`, { replace: false });
    }
  }, [selectedYear, userAuthState, navigate]);

  return <></>;
};

export default ViewTeamIndexRoute;
